import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import CarrierEditModal from 'components/CarrierEditModal';

import { getCurrentCarrier } from 'redux/modules/carrier-section/selectors';

import { updateCarrier as updateCarrierAction } from 'actions/carriers';
import { removeCarrier as removeCarrierAction } from 'actions/carriers';
import { CARRIER_STATES } from 'components/CarrierDetails/Constants';

class CarrierEdit extends Component {
  static propTypes = {
    updateCarrier: PropTypes.func,
    removeCarrier: PropTypes.func,
    onCloseModal: PropTypes.func,
    carrier: PropTypes.object,
  };

  render() {
    const { carrier, updateCarrier, removeCarrier, onCloseModal, history, isEditCarrierLite } =
      this.props;
    if (!carrier) {
      return null;
    }

    return carrier ? (
      <CarrierEditModal
        show={true}
        onClose={onCloseModal}
        carrier={carrier}
        onSave={(oldCarrier) =>
          updateCarrier({
            ...oldCarrier,
            vehicles: undefined,
            drivers: undefined,
          }).then((newCarrier) => {
            onCloseModal();
            if (newCarrier.status === CARRIER_STATES.removed) {
              history.push('/carrier');
            }
          })
        }
        remove={async (oldCarrier) => {
          const newCarrier = await removeCarrier({
            ...oldCarrier,
          });
          onCloseModal();
          if (newCarrier.status === CARRIER_STATES.removed) {
            history.push('/carrier');
          }
        }}
        isEditCarrierLite={isEditCarrierLite}
      />
    ) : null;
  }
}

const actionCreators = {
  updateCarrier: updateCarrierAction,
  removeCarrier: removeCarrierAction,
};

export default connect((state, { match }) => {
  const currentId = parseInt(match?.params.id, 10);

  return {
    currentId: currentId,
    carrier: getCurrentCarrier(state),
  };
}, actionCreators)(CarrierEdit);
